// extracted by mini-css-extract-plugin
export default {"Container":"UpdateBook_Container__tIMxo"};